/**
 * inlineEmphasis — Walter 2026-07-16 (format-menu refresh). Pure
 * toggle-wrap for inline emphasis markers (`**bold**`, `*italic*`), shared by
 * the Format menu's Bold/Italic buttons on BOTH editors. Semantics mirror
 * MarkdownEditor's CM6 `wrapSelection` exactly, so menu-bold and Ctrl+B behave
 * identically:
 *
 *   1. markers INSIDE the selection  → unwrap (strip them);
 *   2. markers just OUTSIDE the selection (or an empty caret sitting between
 *      a fresh pair)                 → remove them;
 *   3. otherwise                     → wrap; an empty caret lands between the
 *      markers, ready to type.
 *
 * Returns the same `{ nextValue, nextSelStart, nextSelEnd, changed }` shape as
 * lib/highlightMarkers transforms so formatTarget's applyToTarget can commit it
 * through the shared path.
 */

export function toggleInlineWrap(content, selStart, selEnd, mark) {
  const value = content || '';
  const n = mark.length;
  const s = Math.max(0, Math.min(selStart, value.length));
  const e = Math.max(s, Math.min(selEnd, value.length));
  const inner = value.slice(s, e);

  // 1. Already wrapped, markers inside the selection → unwrap.
  if (inner.length >= 2 * n && inner.startsWith(mark) && inner.endsWith(mark)) {
    const stripped = inner.slice(n, inner.length - n);
    return {
      nextValue: value.slice(0, s) + stripped + value.slice(e),
      nextSelStart: s,
      nextSelEnd: s + stripped.length,
      changed: true,
    };
  }

  // 2. Markers sit just outside the selection (incl. empty caret between a
  //    fresh pair) → remove them.
  const before = s - n >= 0 ? value.slice(s - n, s) : '';
  const after = e + n <= value.length ? value.slice(e, e + n) : '';
  if (before === mark && after === mark) {
    return {
      nextValue: value.slice(0, s - n) + inner + value.slice(e + n),
      nextSelStart: s - n,
      nextSelEnd: e - n,
      changed: true,
    };
  }

  // 3. Wrap. Empty selection → caret between the markers.
  return {
    nextValue: value.slice(0, s) + mark + inner + mark + value.slice(e),
    nextSelStart: s + n,
    nextSelEnd: e + n,
    changed: true,
  };
}
